function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.397 12.84l-.057.425.337.265 1.823 1.433-1.688 2.92-2.162-.869-.4-.16-.34.263a6.11 6.11 0 01-1.443.838l-.4.163-.06.427-.326 2.305h-3.372l-.326-2.305-.06-.427-.4-.163a6.318 6.318 0 01-1.45-.842l-.338-.258-.395.159-2.162.869-1.688-2.919 1.84-1.432.353-.275-.073-.44A5.12 5.12 0 015.55 12c0-.252.033-.536.08-.817l.073-.44-.352-.275L3.51 9.036l1.679-2.918 2.161.868.394.158.338-.255c.45-.34.934-.634 1.45-.844l.4-.163.06-.427.327-2.305h3.372l.326 2.305.06.427.4.163c.519.21.992.494 1.45.842l.338.257.395-.158 2.162-.869 1.688 2.919-1.84 1.432-.353.275.073.44c.042.25.06.526.06.817 0 .3-.018.576-.053.84zm2.302-3.952h0s0 0 0 0h0z",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 3.25,
  stroke: "currentColor",
  strokeWidth: 1.5
});

function SvgSettingsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgSettingsIcon;